import { combineReducers } from "redux";

import aarsrapportFilterFormReducer from "./aarsrapportFilterFormReducer";
import antallIleggelserPerIleggelsetypeFilterFormReducer from "./antallIleggelserPerIleggelsetypeFilterFormReducer";
import elsparksykkelGebyrFilterFormReducer from "./elsparksykkelGebyrFilterFormReducer";
import ettersendelserFilterFormReducer from "./ettersendelserFilterFormReducer";
import grunndataFilterFormReducer from "./grunndataFilterFormReducer";
import ileggelserOversiktFilterFormReducer from "./ileggelserOversiktFilterFormReducer";
import InnsynIleggelserFilterFormReducer from "./InnsynIleggelserFilterFormReducer";
import InnsynMiljogebyrerFilterFormReducer from "./InnsynMiljogebyrerFilterFormReducer";
import InnsynMotorvognFilterFormReducer from "./innsynMotorvognFilterFormReducer";
import InnsynPersonopplysningerFilterFormReducer from "./InnsynPersonopplysningerFilterFormReducer";
import KlageIleggelseFilerFormReducer from "./klageIleggelseFilterFormReducer";
import klageRapportFilterFormReducer from "./KlageRapportFilterFormReducer";
import klageVedtakerFormReducer from "./klageVedtakerFormReducer";
import makuleringerFilterFormReducer from "./makuleringerFilterFormReducer";
import miljogebyrerOversiktFilterFormReducer from "./miljogebyrerOversiktFilterFormReducer";
import miljogebyrTilBehandlingFilterFormReducer from "./miljogebyrTilBehandlingFilterFormReducer";
import miljokontrollOversiktFilterFormReducer from "./miljokontrollOversiktFilterFormReducer";
import piggdekkontrollFilterFormReducer from "./piggdekkontrollFilterFormReducer";
import rapportJuridiskSaksbehandlerFilterFormReducer from "./rapportJuridiskSaksbehandlerFilterFormReducer";
import SkiftloggFilterFormReducer from "./SkiftloggFilterFormReducer";
import ubetalteIleggelserFilterFormReducer from "./ubetalteIleggelserFilterFormReducer";
import uregistrertekontrollerFilterFormReducer from "./uregistrertekontrollerFilterFormReducer";
import VentilstillingFilterFormReducer from "./VentilstillingFilterFormReducer";

export default combineReducers({
  aarsrapportFilterForm: aarsrapportFilterFormReducer,
  antallIleggelserPerIleggelsetypeFilterForm:
    antallIleggelserPerIleggelsetypeFilterFormReducer,
  grunndataFilterForm: grunndataFilterFormReducer,
  ileggelserOversiktFilterForm: ileggelserOversiktFilterFormReducer,
  elsparksykkelGebyrFilterForm: elsparksykkelGebyrFilterFormReducer,
  ettersendelserFilterForm: ettersendelserFilterFormReducer,
  miljogebyrerOversiktFilterForm: miljogebyrerOversiktFilterFormReducer,
  miljogebyrTilBehandlingFilterForm: miljogebyrTilBehandlingFilterFormReducer,
  miljokontrollOversiktFilterForm: miljokontrollOversiktFilterFormReducer,
  uregistrertekontrollerFilterForm: uregistrertekontrollerFilterFormReducer,
  ubetalteIleggelserFilterForm: ubetalteIleggelserFilterFormReducer,
  SkiftloggFilterForm: SkiftloggFilterFormReducer,
  piggdekkontrollFilterForm: piggdekkontrollFilterFormReducer,
  VentilstillingFilterForm: VentilstillingFilterFormReducer,
  rapportJuridiskSaksbehandlerFilterForm:
    rapportJuridiskSaksbehandlerFilterFormReducer,
  InnsynIleggelserFilterFormState: InnsynIleggelserFilterFormReducer,
  InnsynMiljogebyrerFilterFormState: InnsynMiljogebyrerFilterFormReducer,
  innsynMotorvognFilterForm: InnsynMotorvognFilterFormReducer,
  innsynPersonopplysningerFilterForm: InnsynPersonopplysningerFilterFormReducer,
  KlageIleggelseFilterFormState: KlageIleggelseFilerFormReducer,
  klageVedtakerForm: klageVedtakerFormReducer,
  klageRapportFilterForm: klageRapportFilterFormReducer,
  makuleringerFilterForm: makuleringerFilterFormReducer,
});
